import { render } from "./vresourcesglobaladd.vue?vue&type=template&id=37746dcb&scoped=true"
import script from "./vresourcesglobaladd.vue?vue&type=script&lang=js"
export * from "./vresourcesglobaladd.vue?vue&type=script&lang=js"

import "./vresourcesglobaladd.vue?vue&type=style&index=0&id=37746dcb&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37746dcb"]])

export default __exports__